import React from "react";
import { NavLink, Link } from "react-router-dom";
import { ROLES, useRole } from "../lib/roles.jsx";

const NAV = [
    { to: "/", label: "Overview", end: true },
    { to: "/workbench", label: "Referral Workbench" },
    { to: "/portfolio", label: "Portfolio" },
    { to: "/diagnostics", label: "Diagnostics" },
];

export default function Header() {
    const { roleId, setRoleId } = useRole();
    return (
        <header className="bg-parchment border-b border-parchment-rule" data-testid="site-header">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
                <div className="flex items-baseline gap-4">
                    <Link to="/" className="flex flex-col gap-1" data-testid="brand-link">
                        <span className="font-serif text-2xl tracking-tight text-ink leading-none">
                            ReferralCierge
                        </span>
                        <span className="font-sans text-[12px] text-ink-secondary leading-tight">
                            Partner-enabled underwriting governance
                        </span>
                    </Link>
                    <span
                        className="hidden xl:inline font-mono text-[10px] uppercase tracking-[0.24em] text-ink-muted/70"
                        data-testid="brand-demo-label"
                    >
                        A KATLAS Cierge demo
                    </span>
                </div>

                <nav className="flex flex-wrap items-center gap-6">
                    {NAV.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            end={n.end}
                            data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className={({ isActive }) =>
                                "nav-link pb-1 " + (isActive ? "nav-link-active" : "")
                            }
                        >
                            {n.label}
                        </NavLink>
                    ))}
                </nav>

                <div
                    className="flex items-center gap-0 border border-parchment-rule"
                    data-testid="role-switcher"
                >
                    <span className="label-eyebrow px-3 py-2 border-r border-parchment-rule bg-[#F2EFE9]">
                        Role
                    </span>
                    {ROLES.map((r) => {
                        const active = roleId === r.id;
                        return (
                            <button
                                key={r.id}
                                onClick={() => setRoleId(r.id)}
                                data-testid={`role-btn-${r.id}`}
                                className={
                                    "px-3 py-2 font-mono text-[11px] uppercase tracking-[0.16em] border-r last:border-r-0 border-parchment-rule transition-colors duration-150 " +
                                    (active
                                        ? "bg-forest text-parchment"
                                        : "text-ink-secondary hover:text-ink hover:bg-[#F2EFE9]")
                                }
                            >
                                {r.label.split(" ")[0]}
                            </button>
                        );
                    })}
                </div>
            </div>
        </header>
    );
}
